import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a01df04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Calendario", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ricerca clienti", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Amministratori", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/calendar",
      class: "menu__element"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_icon, { icon: _ctx.calendarOutline }, null, 8, ["icon"]),
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/search",
      class: "menu__element"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_icon, { icon: _ctx.searchOutline }, null, 8, ["icon"]),
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/administratorList",
      class: "menu__element"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_icon, { icon: _ctx.peopleOutline }, null, 8, ["icon"]),
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}